import { gql } from '@apollo/client';

export const GRAPHQL_BUSCAR_TAXAS = gql`
    query BuscarTaxas($first: Int, $after: String) {
        taxas(first: $first, after: $after) {
            data {
                id
                dataInicio
                dataFim
                valorAdicionalJogoRapido
                valorAdicionalEntregador
                criadoEm
                status
                u_nomeCompleto
            }
            hasNextPage
        }
    }
`;

export const GRAPHQL_CRIAR_TAXA = gql`
    mutation CriarTaxa($data: CriarTaxaInput!) {
        criarTaxa(data: $data) {
            id
            dataInicio
            dataFim
            valorAdicionalJogoRapido
            valorAdicionalEntregador
            criadoEm
        }
    }
`;

export const GRAPHQL_EXCLUIR_TAXA = gql`
    mutation ExcluirTaxa($id: ID!) {
        excluirTaxa(id: $id)
    }
`;

export const GRAPHQL_ALTERAR_STATUS_TAXA = gql`
    mutation AlterarStatusTaxa($id: ID!, $status: Int!) {
        alterarStatusTaxa(id: $id, status: $status) {
            id
            status
        }
    }
`;
